import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Backdrop, Fade } from '@material-ui/core';
import Text from '../Typography/Text';
import TextField from '../Textfields/TextField';
import AutoCompleteAccountNo from '../AutoComplete/AutoCompleteAccountNo';
import AutoCompleteSymbol from '../AutoComplete/AutoCompleteSymbol';
import SelectSystemCode from '../Dropdown/SelectSystemCode';
import TextEditor from '../TextEditor/TextEditor';
import Button from '../Buttons/Button';
import CloseButton from '../Buttons/CloseButton';
import fontFamily from '../../assets/css/fonts';
import color from '../../assets/css/colors';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 800,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& div:nth-child(1)': {
      flex: 1,
    },
    '& div:nth-child(2)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    fontFamily: fontFamily.headers,
    '& p': {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-4px !important',
    },
  },
}));

export default function WalletModal(props) {
  const classes = useStyles();

  const { data, open, close, loading } = props;
  const { walletId, note } = data;

  const [modalData, setModalData] = React.useState({
    walletId: 0,
    accountId: 0,
    symbol: '',
    accountNo: '',
    wallet: '',
    status: '',
  });

  const [modalNote, setModalNote] = React.useState('');

  React.useEffect(() => {
    if (open) {
      setModalData(data);
      setModalNote(note);
    }
  }, [open, data, note]);

  const handleChange = (e) => {
    const input = e?.currentTarget?.name ? e?.currentTarget : e?.target;
    if (input?.name === 'accountNo') {
      modalData.accountId = input.data ? input.data.accountId : 0;
    }
    setModalData({ ...modalData, [input.name]: input.value });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={() => close()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <div style={{ width: 800 }}>
          <div className={classes.modalHeader}>
            <div>
              <Text mt={4} variant="h2" label={(walletId ? 'Edit' : 'Add') + ' Wallet'} />
            </div>
            <div className={classes.closeButton}>
              <CloseButton onClick={() => close()} />
            </div>
          </div>
          <div className={classes.modalBody}>
            <div className="grd-row nm">
              <div className="grd-cell">
                <AutoCompleteSymbol
                  disabled={walletId ? true : false}
                  name="symbol"
                  value={modalData.symbol}
                  onChange={handleChange}
                  assetType="DA"
                  isActive
                />
              </div>
              <div className="grd-cell">
                <AutoCompleteAccountNo
                  disabled={walletId ? true : false}
                  isActive
                  name="accountNo"
                  value={modalData.accountNo}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <TextField
                  required={true}
                  disabled={walletId ? true : false}
                  max={42}
                  name="wallet"
                  label="Wallet"
                  placeholder="Wallet"
                  type="text"
                  value={modalData.wallet}
                  onChange={handleChange}
                />
              </div>
              <div className="grd-cell">
                <SelectSystemCode
                  required={true}
                  disabled={
                    walletId &&
                    ['Active', 'Disabled', 'Pending Approval'].includes(modalData.status)
                      ? false
                      : true
                  }
                  name="status"
                  label="Status"
                  placeholder="Status"
                  type="Status"
                  subType="Bank Account"
                  useFor="Wallet"
                  value={modalData.status}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <TextEditor
                  name="note"
                  label="Note"
                  value={modalNote}
                  setContents={modalNote}
                  onChange={setModalNote}
                />
              </div>
            </div>
          </div>
          <div className={classes.modalFooter}>
            <Button
              disabled={loading}
              loading={loading}
              label={loading ? 'Saving...' : 'Save'}
              onClick={() =>
                close({ ...modalData, note: modalNote }, walletId ? true : false)
              }
            />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
